<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div class="router-test">
                <span class="fs-12">Vue路由:</span>
                <div class="mb-20 b-r-4 b-1sd">
                    <el-menu theme="red" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                        <el-menu-item index="1">
                            <router-link to="/home/indexN">router无值</router-link>
                        </el-menu-item>
                        <el-menu-item index="2">
                            <router-link to="/home/index1/1">热点</router-link>
                        </el-menu-item>
                        <el-menu-item index="3">
                            <router-link to="/home/index2/2">订阅</router-link>
                        </el-menu-item>
                    </el-menu>
                    <div class="route-view">
                        <transition name="view-option-transition" >
                            <router-view :user='users' />
                        </transition>
                    </div>
                </div>
                <div>
                    <span class="fs-12">Vue键盘事件:</span>
                    <el-table :data="keyCodeData" stripe border style="width: 100%" class="mb-20">
                        <el-table-column prop="name" label="别名" width="240"></el-table-column>
                        <el-table-column prop="key" label="实际键值"></el-table-column>
                    </el-table>
                    <span class="fs-12">Vue键盘事件测试:</span>
                    <el-input v-model="input" size="small"
                        placeholder="Vue键盘事件测试"
                        @keyup.delete.native="keyupDelete"
                        @keyup.enter.native="keyupEnter"
                        @keyup.tab.native="keyupTab"
                        @keyup.esc.native="keyupEsc"
                        @keyup.space.native="keyupSpace"
                        @keyup.left.native="keyupLeft"
                        @keyup.up.native="keyupUp"
                        @keyup.right.native="keyupRight"
                        @keyup.down.native="keyupDown"
                        @keyup.ctrl.native="keyupCtrl"
                        @keyup.alt.native="keyupAlt"
                        @keyup.shift.native="keyupShift"
                        @keyup.meta.native="keyupMeta"
                        @keyup.alt.67.native="keyupAltC"
                        @click.ctrl.native="clickCtrl"
                        @keydown="alertKeyCode($event)"
                    ></el-input>
                </div>
                <template-1>
                    <template-2 name="temp2"></template-2>
                </template-1>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    import Template1 from './temp1.vue'
    import Template2 from './temp2.vue'
    export default {
        data(){
            return {
                activeIndex:'1',
                users:[],
                input:'',
                keyCodeData: [
                    {
                        name: '.delete',
                        key:'delete（删除）/BackSpace（退格）'
                    }, {
                        name: '.tab',
                        key:'Tab'
                    }, {
                        name: '.enter',
                        key:'Enter（回车）'
                    }, {
                        name: '.esc',
                        key:'Esc（退出）'
                    }, {
                        name: '.space',
                        key:'Space（空格键）'
                    }, {
                        name: '.left',
                        key:'Left（左箭头）'
                    }, {
                        name: '.up',
                        key:'Up（上箭头）'
                    }, {
                        name: '.right',
                        key:'Right（右箭头）'
                    }, {
                        name: '.down',
                        key:'Down（下箭头）'
                    }, {
                        name: '.ctrl',
                        key:'Ctrl'
                    }, {
                        name: '.alt',
                        key:'Alt'
                    }, {
                        name: '.shift',
                        key:'Shift'
                    }, {
                        name: '.meta',
                        key:'(window系统下是window键，mac下是command键)'
                    }, {
                        name: '@keyup.alt.67=”function”',
                        key:'Alt + C'
                    }, {
                        name: '@click.ctrl=”function”',
                        key:'Ctrl + Click'
                    }
                ],
            }
        },
        components:{
            Template1,
            Template2
        },
        methods:{
            handleSelect(key, keyPath) {
                this.activeIndex = keyPath[0];
            },
            open(val) {
                this.$message(val);
            },
            keyupDelete(e){
                if (e.keyCode === 8){
                    this.open('backspace');
                } else {
                    this.open('delete')
                }
            },
            keyupEnter(){
                this.open('enter')
            },
            keyupTab(){
                this.open('tab')
            },
            keyupEsc(){
                this.open('esc')
            },
            keyupSpace(){
                this.open('space')
            },
            keyupLeft(){
                this.open('left')
            },
            keyupUp(){
                this.open('up')
            },
            keyupRight(){
                this.open('right')
            },
            keyupDown(){
                this.open('down')
            },
            keyupCtrl(){
                this.open('ctrl')
            },
            keyupAlt(){
                this.open('alt')
            },
            keyupShift(){
                this.open('shift')
            },
            keyupMeta(){
                this.open('meta')
            },
            keyupAltC(){
                this.open('alt + c')
            },
            clickCtrl(){
                this.open('click + ctrl')
            },
            alertKeyCode(e){
                this.open(e.keyCode)
            }
        },
        created(){
            this.$http.get('http://jsonplaceholder.typicode.com/users').then(res => {
                this.users = res.body;
            })
            this.$parent.routerLoading();
        }
    }
</script>
<style scoped lang="scss">
    .el-menu-item{
        padding: 0;
        a{
            padding: 0 20px;
            width: 100%;
            height: 100%;
            display: block;
        }
    }
    .route-view{
        width: 100%;
        height: 200px;
        padding: 10px;
        overflow: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/router-test/index.vue